<script>
  import fileTemplateState from "../../stores/fileTemplateJsonData"
  import { onMount } from "svelte"
  import cursorPosition from "../../stores/cursorPosition"
  import notify from "../../../../../Script/notify"

  /**
   * @type {HTMLCanvasElement}
   */
  let canvas
  /**
   * @type {CanvasRenderingContext2D}
   */
  let ctx

  // let $fileTemplateState.canvasScale = 0
  const textPadding = 1.3
  const textPaddingOffset = textPadding * 0.75

  let xValue1
  let xValue2
  let yValue1
  let yValue2
  /**
   *
   * @param {MouseEvent} event
   */
  let dragg = false
  let scaleCanvas = false
  let dragCanvas = false
  let pos1 = 0,
    pos2 = 0,
    pos3 = 0,
    pos4 = 0
  let elmnt

  onMount(async () => {
    try {
      // console.log($fileTemplateState.scale, "hjfjd")
      // console.log(elmnt.offsetTop, elmnt.offsetLeft, elmnt.clientHeight, elmnt.clientWidth, "topLeft")
      ctx = canvas.getContext("2d")
      canvas.height = $fileTemplateState.baseImageInfo.height
      canvas.width = $fileTemplateState.baseImageInfo.width

      // console.log(canvas.clientWidth, canvas.clientHeight, "cWcH")
      $fileTemplateState.scale = 1
      window.requestAnimationFrame(watcher)
      $fileTemplateState.canvasScale = $fileTemplateState.baseImageInfo.width / canvas.clientWidth
      $fileTemplateState.canvasHeight = canvas.clientHeight
      $fileTemplateState.activeFontSize = Math.floor($fileTemplateState.canvasHeight * (10 / 100))
      fileTemplateState.subscribe((state) => {
        window.requestAnimationFrame(watcher)
      })
    } catch (error) {
      const info = "PAGE: File template Editor (Document Preview)\nEVENT: onMount"
      notify.danger(error, info)
    }
  })

  const loadImage = (uri) => {
    return new Promise((resolve, reject) => {
      let img = new Image()
      img.onload = () => {
        resolve(img)
      }
      img.onerror = (error) => {
        reject("Image failed to load.")
      }
      img.src = uri
    })
  }

  /**
   * @param {Array} operations
   */
  const watcher = async () => {
    try {
      if (!$fileTemplateState.baseImageInfo.uri) return

      // ctx.drawImage(await loadImage($fileTemplateState.baseImageInfo.uri), 0, 0, $fileTemplateState.baseImageInfo.width, $fileTemplateState.baseImageInfo.height)
      const img = await loadImage($fileTemplateState.baseImageInfo.uri)
      // console.log("Loaded Image:", img)
      ctx.drawImage(img, 0, 0, $fileTemplateState.baseImageInfo.width, $fileTemplateState.baseImageInfo.height)
      for (let i = 0; i < $fileTemplateState.operations.length; i++) {
        if ($fileTemplateState.operations[i].type == "text") await renderText($fileTemplateState.operations[i])
        else if ($fileTemplateState.operations[i].type == "image" || $fileTemplateState.operations[i].type == "qr") {
          if ($fileTemplateState.operations[i].image) {
            if ($fileTemplateState.operations[i].image instanceof HTMLImageElement == false) return

            if ($fileTemplateState.operations[i].dynamic) {
              if (!$fileTemplateState.operations[i].uploadImage) {
                let width = $fileTemplateState.operations[i].width
                let height = $fileTemplateState.operations[i].height
                let xPos = $fileTemplateState.operations[i].x
                let yPos = $fileTemplateState.operations[i].y

                if ($fileTemplateState.operations[i].aspectRatio >= 1) {
                  height = Math.floor($fileTemplateState.operations[i].width / $fileTemplateState.operations[i].aspectRatio)
                  yPos += ($fileTemplateState.operations[i].height - height) / 2
                } else {
                  width = Math.floor($fileTemplateState.operations[i].height * $fileTemplateState.operations[i].aspectRatio)
                  xPos += ($fileTemplateState.operations[i].width - width) / 2
                }
                ctx.drawImage(
                  // await loadImage($fileTemplateState.operations[i].image.src),
                  $fileTemplateState.operations[i].image,
                  xPos,
                  yPos,
                  width,
                  height
                )
              } else {
                ctx.drawImage(
                  // await loadImage($fileTemplateState.operations[i].image.src),
                  $fileTemplateState.operations[i].image,
                  $fileTemplateState.operations[i].x,
                  $fileTemplateState.operations[i].y,
                  $fileTemplateState.operations[i].width,
                  $fileTemplateState.operations[i].height
                )
              }
            } else {
              ctx.drawImage(
                // await loadImage($fileTemplateState.operations[i].image.src),
                $fileTemplateState.operations[i].image,
                $fileTemplateState.operations[i].x,
                $fileTemplateState.operations[i].y,
                $fileTemplateState.operations[i].width,
                $fileTemplateState.operations[i].height
              )
            }
          }

          if (($fileTemplateState.operations[i].active || $fileTemplateState.operations[i].hover) && $fileTemplateState.operations[i].image) {
            ctx.lineWidth = 3
            ctx.strokeStyle = "rgba(56, 189, 248, 0.6)"
            ctx.strokeRect($fileTemplateState.operations[i].x - 20, $fileTemplateState.operations[i].y - 20, $fileTemplateState.operations[i].width + 40, $fileTemplateState.operations[i].height + 40)
          }
        }
      }
    } catch (error) {
      console.error(error)
      const info = "PAGE: File template Editor (Document Preview)\nEVENT: While redrawing canvas based on layer changes"
      notify.danger(error, info)
    }
  }

  // download certificate
  $: if ($fileTemplateState.download) {
    const anchor = document.createElement("a")
    anchor.href = canvas.toDataURL("image/jpeg", $fileTemplateState.baseImageInfo.Quality)
    anchor.download = $fileTemplateState.baseImageInfo.name
    anchor.click()
    $fileTemplateState.download = false

    setTimeout(() => {
      $fileTemplateState.notifyFooter = ""
    }, 2000)
  }

  /**
   *
   * @param {import("../../stores/fileTemplateJsonData").OperationLayersItem} data
   */
  const renderText = (data) => {
    return new Promise((resolve) => {
      if (canvas) {
        if (data.active || data.hover) {
          ctx.fillStyle = "rgb(56, 189, 248, 0.2)"
          // ctx.fillRect(x, y, w, h)
          let x = 0
          if (data.textAlign == "left") {
            x = data.x
            ctx.fillRect(x, data.y - data.fontSize * textPaddingOffset, canvas.width, data.fontSize * textPadding)
          } else if (data.textAlign == "center") {
            x = 0
            ctx.fillRect(x, data.y - data.fontSize * textPaddingOffset, canvas.width, data.fontSize * textPadding)
          } else if (data.textAlign == "right") {
            x = -data.x
            ctx.fillRect(data.x, data.y - data.fontSize * textPaddingOffset, x, data.fontSize * textPadding)
          }
          // ctx.fillRect(data.x, data.y - data.fontSize / 2, canvasWidth, data.fontSize)
        }
        // if (!data.active && !data.hover) scale = 1
        // if (!data.value) data.value = "Enter your text"
        if (data.fontStyles.length) {
          data.fontStyles = [...new Set(data.fontStyles)]
          let fontStyle = data.fontStyles.toString().replaceAll(",", " ")
          fontStyle = fontStyle.replace("Underline", " ")
          ctx.font = `${fontStyle} ${data.fontSize}px '${data.fontFamily}'`
        } else {
          ctx.font = ` ${data.fontSize}px '${data.fontFamily}'`
        }

        ctx.textAlign = data.textAlign
        ctx.fillStyle = data.textColor
        ctx.fillText(data.value ? data.value : "Enter your text", data.x, data.y)

        // if (data.fontStyles.includes("Underline")) {
        //   let { width } = ctx.measureText(data.value)
        //   if (data.textAlign == "left") {
        //     ctx.fillRect(data.x, data.y, width, 10)
        //   } else if (data.textAlign == "center") {
        //     ctx.fillRect(data.x - width / 2, data.y, width, 10)
        //   } else if (data.textAlign == "right") {
        //     ctx.fillRect(data.x, data.y, -width, 10)
        //   }
        // }
        if (data.fontStyles.includes("Underline")) {
          let { width, actualBoundingBoxDescent } = ctx.measureText(data.value) // Measure text
          let underlineY = data.y + actualBoundingBoxDescent + 2 // Adjust underline position below text

          if (data.textAlign === "left") {
            ctx.fillRect(data.x, underlineY, width, 3) // Draw underline for left alignment
          } else if (data.textAlign === "center") {
            ctx.fillRect(data.x - width / 2, underlineY, width, 3) // Centered underline
          } else if (data.textAlign === "right") {
            ctx.fillRect(data.x - width, underlineY, width, 3) // Right-aligned underline
          }
        }
      }
      resolve()
    })
  }
  /**
   *
   * @param {import("../../../../../Stores/fileTemplateJsonData").OperationLayersItem} data
   */

  /**
   *
   * @param {Number} width -width of the checked canvas
   * @param {Number} height - height of the checked canvas
   * @param {Number} side - width & height of the each checked box
   */

  const handleMousemove = (event) => {
    $cursorPosition.originalX = event.offsetX
    $cursorPosition.originalY = event.offsetY
    $cursorPosition.x = Math.floor(event.offsetX * $fileTemplateState.canvasScale)

    $cursorPosition.y = Math.floor($fileTemplateState.baseImageInfo.height - event.offsetY * $fileTemplateState.canvasScale)

    if (dragCanvas) {
      // const containerRect = elmnt.getBoundingClientRect() // Get the container's dimensions

      pos1 = pos3 - event.clientX

      pos2 = pos4 - event.clientY
      pos3 = event.clientX
      pos4 = event.clientY

      if (elmnt.offsetTop <= elmnt.clientHeight && elmnt.offsetTop >= -elmnt.clientHeight) {
        elmnt.style.top = elmnt.offsetTop - pos2 + "px"
      }
      // if (elmnt.offsetTop <= elmnt.clientHeight / 2 && elmnt.offsetTop >= -(elmnt.clientHeight / 2)) {
      //   elmnt.style.top = elmnt.offsetTop - pos2 + "px"
      // }
      if (elmnt.offsetLeft <= elmnt.clientWidth / 2 && elmnt.offsetLeft >= -(elmnt.clientWidth / 2)) {
        elmnt.style.left = elmnt.offsetLeft - pos1 + "px"
      }
      if (elmnt.offsetTop >= elmnt.clientHeight / 2 && pos2 > 0) {
        elmnt.style.top = elmnt.offsetTop - pos2 + "px"
      }
      if (elmnt.offsetLeft >= elmnt.clientWidth / 2 && pos1 > 0) {
        elmnt.style.left = elmnt.offsetLeft - pos1 + "px"
      }
      if (elmnt.offsetTop <= -(elmnt.clientHeight / 2) && pos2 < 0) {
        elmnt.style.top = elmnt.offsetTop - pos2 + "px"
      }
      if (elmnt.offsetLeft <= -(elmnt.clientWidth / 2) && pos1 < 0) {
        elmnt.style.left = elmnt.offsetLeft - pos1 + "px"
      }
    }

    if (dragg && event.button == 0) {
      $fileTemplateState.runWatcher = true
      xValue2 = Math.floor(event.offsetX * $fileTemplateState.canvasScale)
      yValue2 = Math.floor($fileTemplateState.baseImageInfo.height - event.offsetY * $fileTemplateState.canvasScale)

      let xValue = xValue2 - xValue1
      let yValue = yValue2 - yValue1

      xValue1 = xValue2
      yValue1 = yValue2

      $fileTemplateState.operations.map((operation) => {
        if (operation.active) {
          operation.x = Math.floor(operation.x + xValue)
          operation.y = Math.floor(operation.y - yValue)
          if (operation.type == "image" || operation.type == "qr") {
            operation.inputY = $fileTemplateState.baseImageInfo.height - operation.height - operation.y
          } else {
            operation.inputY = $fileTemplateState.baseImageInfo.height - operation.y
          }
        }
        return operation
      })
    }
  }
  const stopMove = () => {
    // red color layers
    $fileTemplateState.operations = $fileTemplateState.operations.map((opp) => {
      if (opp.type == "text") {
        opp.errorX = opp.x < 0 || opp.x > $fileTemplateState.baseImageInfo.width
        opp.errorY = opp.y < 0 || opp.y > $fileTemplateState.baseImageInfo.height
      } else {
        opp.errorX = opp.x < 0 || opp.x + opp.width > $fileTemplateState.baseImageInfo.width
        opp.errorY = opp.y < 0 || opp.y + opp.height > $fileTemplateState.baseImageInfo.height
      }
      opp.move = false
      return opp
    })
    // $fileTemplateState.operations = $fileTemplateState.operations.map((opp) => {
    //   if (opp.type == "text") {
    //     let textMetrics = ctx.measureText(opp.value)
    //     let textWidth = textMetrics.width
    //     let textHeight = textMetrics.actualBoundingBoxAscent + textMetrics.actualBoundingBoxDescent

    //     opp.errorX = opp.x < 0 || opp.x + textWidth > $fileTemplateState.baseImageInfo.width
    //     opp.errorY = opp.y < 0 || opp.y + textHeight > $fileTemplateState.baseImageInfo.height
    //   } else {
    //     opp.errorX = opp.x < 0 || opp.x + opp.width > $fileTemplateState.baseImageInfo.width
    //     opp.errorY = opp.y < 0 || opp.y + opp.height > $fileTemplateState.baseImageInfo.height
    //   }

    //   opp.move = false
    //   return opp
    // })
  }

  $: cursorClass = $fileTemplateState.operations.filter((opp) => opp.active == true)

  const resetScale = (scale) => {
    if (scale == 1 && elmnt) {
      elmnt.style.left = 0
      elmnt.style.top = 0
      scaleCanvas = false
      dragCanvas = false
    }
  }

  $: resetScale($fileTemplateState.scale)
</script>

<svelte:window
  on:mouseup={() => {
    dragg = false
    dragCanvas = false
  }}
/>

<div bind:this={elmnt} class="absolute inset-0 flex h-full w-full select-none items-center justify-center px-12 pb-12 pt-5">
  <canvas
    style="scale: {$fileTemplateState.scale};"
    on:mousedown={(e) => {
      if (e.button == 1 && $fileTemplateState.scale < 2.5) {
        scaleCanvas = true
      }
      if (scaleCanvas && e.button == 1) {
        dragCanvas = true
        // Get the mouse cursor position at startup:
        pos3 = e.clientX
        pos4 = e.clientY
      }

      if (e.button == 0) {
        scaleCanvas = false
        dragg = true
      }
      xValue1 = Math.floor(e.offsetX * $fileTemplateState.canvasScale)
      yValue1 = Math.floor($fileTemplateState.baseImageInfo.height - e.offsetY * $fileTemplateState.canvasScale)
    }}
    on:mouseup={() => {
      dragg = false
      dragCanvas = false
    }}
    on:wheel|preventDefault|stopPropagation={(e) => {
      if (e.deltaY < 0) {
        if ($fileTemplateState.scale < 2.5) {
          scaleCanvas = true
          $fileTemplateState.scale = $fileTemplateState.scale + 0.1
        }
      } else {
        if ($fileTemplateState.scale > 1 && $fileTemplateState.scale < 3) {
          $fileTemplateState.scale = $fileTemplateState.scale - 0.1
        } else $fileTemplateState.scale = 1
      }
    }}
    on:click={stopMove}
    on:mousemove={handleMousemove}
    bind:this={canvas}
    id="fileTempCanvas"
    alt="preview image"
    class="m-10 max-h-[400px] xl:m-0 xls:max-h-[650px] {cursorClass.length ? 'cursor-all-scroll' : ''} {dragCanvas ? 'cursor-grab' : ''}  overflow-hidden rounded-md"
  />
</div>
<!-- class="m-10 h-auto max-h-[400px] w-full overflow-hidden rounded-md xl:m-0 sxl:max-h-[650px] {cursorClass.length ? 'cursor-all-scroll' : ''} {dragCanvas ? 'cursor-grab' : ''}" -->
